import { render } from "./BookPreviewComponent.vue?vue&type=template&id=2b0fa3e4&scoped=true"
import script from "./BookPreviewComponent.vue?vue&type=script&lang=js"
export * from "./BookPreviewComponent.vue?vue&type=script&lang=js"

import "./BookPreviewComponent.vue?vue&type=style&index=0&id=2b0fa3e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b0fa3e4"]])

export default __exports__